import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { getGraphemeReadings } from "@-/dev.improve.haniverse.assets.words.readings";
import { resolvePronunciationHint } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.pinyin.hint";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import {
  DrillPageContext,
  GraphemeDrillContext,
} from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._context";
import { useMemo } from "react";

/**
 * The hint under a pronunciation review's glyph, for the drilled reading `pinyin`. Null when the
 * character has no hint for that reading (no gloss).
 */
export function useDrillPagePronunciationHint(pinyin: string) {
  const [character] = useContextSelectors(DrillPageContext, (c) => c.character);
  const [slice] = useContextSelectors(GraphemeDrillContext, (c) => c.slice.data);
  const { hanziScript } = useActorUser();

  const pronunciationHint = useMemo(
    () =>
      resolvePronunciationHint({
        cardGloss: slice.back,
        mainPinyin: getGraphemeReadings(hanziScript, character)?.mainPinyin,
        pinyin,
        pinyinList: slice.pinyinList,
      }),
    [character, hanziScript, pinyin, slice],
  );

  return { pronunciationHint };
}
